/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".btn-stacked[_ngcontent-%COMP%]{padding:0 6px;color:#fff;background:0 0;border-radius:0}.btn-stacked[_ngcontent-%COMP%]:focus, .btn-stacked[_ngcontent-%COMP%]:hover{color:#fff}.btn-stacked[_ngcontent-%COMP%]   .fa[_ngcontent-%COMP%]{display:block;font-size:22px;font-weight:700}.btn-stacked[_ngcontent-%COMP%]   .mobile-buttons-text[_ngcontent-%COMP%]{margin:0;font-size:12px}"];
export { styles as styles };
